"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobilePanel = void 0;
const mobilePanel = () => {
    /**
     * Header and navigation hooks
     */
    const nav = document.querySelector(".mobile-panel");
    const navToggle = document.querySelector('[data-panel="toggle"]');
    const root = document.documentElement;
    const body = document.body;
    const breakpoint = 1001;
    if (window.innerWidth < breakpoint) {
        nav.setAttribute("aria-hidden", "true");
    }
    if (!navToggle) {
        return;
    }
    navToggle.addEventListener("click", () => {
        nav.classList.toggle("is-open");
        navToggle.classList.toggle("is-active");
        document.querySelector("body").classList.toggle("has-open-panel");
        if (!navToggle.classList.contains("is-active")) {
            nav.setAttribute("aria-hidden", "true");
            // make links not tabbable
            nav.querySelectorAll("a, button").forEach((ele) => {
                ele.setAttribute("tabindex", "-1");
            });
            const scrollY = body.style.top;
            body.style.position = "";
            body.style.top = "";
            window.scrollTo(0, parseInt(scrollY || "0") * -1);
            root.classList.add("smooth-scroll");
        }
        else {
            nav.setAttribute("aria-hidden", "false");
            // make links tabbable
            nav.querySelectorAll("a, button").forEach((ele) => {
                ele.setAttribute("tabindex", "0");
            });
            const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
            body.style.position = "fixed";
            body.style.top = `-${scrollY}`;
            root.classList.remove("smooth-scroll");
        }
    });
    window.addEventListener("scroll", () => {
        document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
    });
    window.addEventListener("resize", () => {
        if (window.innerWidth >= breakpoint &&
            navToggle.classList.contains("is-active")) {
            const click = new Event("click");
            navToggle.dispatchEvent(click);
        }
    });
    const menus = document.querySelectorAll("[data-menu]");
    document.addEventListener("click", (event) => {
        const target = event.target;
        if (!target.matches("[data-menu-open]"))
            return;
        let menuSlug = target.getAttribute("data-menu-open");
        let activeMenu = document.querySelector('[data-menu="' + menuSlug + '"]');
        if (target.getAttribute("aria-expanded") === "false") {
            activeMenu.setAttribute("aria-hidden", "false");
            target.setAttribute("aria-expanded", "true");
            // tabindex="0"
            // let panelHeight = activeMenu.querySelector('ul').offsetHeight;
            // activeMenu.setAttribute('style', 'height: ' + panelHeight + 'px');
            // activeMenu.closest('[data-menu]').setAttribute('style', 'height: auto');
        }
        else {
            activeMenu.setAttribute("aria-hidden", "true");
            // tabindex="-1"
            target.setAttribute("aria-expanded", "false");
            // activeMenu.setAttribute('style', 'height: 0px');
        }
    });
};
exports.mobilePanel = mobilePanel;
